<template>
  <b-container>
    <b-row>
      <b-col cols="12" class="mb-4 mt-2">
        <p class="h4">Apply for this position</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-row>
          <b-col cols="12">
            <b-form @submit.stop.prevent="submitForm(SUBMIT_FORM_PATH.jobs)" novalidate>
              <b-form-group>
                <a-floating-label for="offer-apply-email" text="Your email address" :required="isRequired('email')">
                  <b-form-input
                    id="offer-apply-email"
                    name="offer-apply-email"
                    autocomplete="email"
                    v-model="form.email"
                    :state="validateState('email')"
                    trim
                    placeholder="myemail@example.com"
                    :disabled="isFormDisabled"
                  />
                </a-floating-label>
                <template v-if="$v.form.email.$error">
                  <m-invalid-feedback :state="$v.form.email.required"> Field is required </m-invalid-feedback>
                  <m-invalid-feedback :state="$v.form.email.email"> Incorrect email format </m-invalid-feedback>
                </template>
              </b-form-group>
              <b-form-group>
                <a-floating-label for="offer-apply-name" text="Your name" :required="isRequired('name')">
                  <b-form-input
                    id="offer-apply-name"
                    name="offer-apply-name"
                    autocomplete="name"
                    v-model="form.name"
                    :state="validateState('name')"
                    trim
                    placeholder=" "
                    :disabled="isFormDisabled"
                  />
                </a-floating-label>
                <template v-if="$v.form.name.$error">
                  <m-invalid-feedback :state="$v.form.name.minLength">
                    Minimal length is {{ $v.form.name.$params.minLength.min }}
                  </m-invalid-feedback>
                  <m-invalid-feedback :state="$v.form.name.maxLength">
                    Maximal length is {{ $v.form.name.$params.maxLength.max }}
                  </m-invalid-feedback>
                </template>
              </b-form-group>
              <b-form-group>
                <m-form-file
                  v-model="form.files"
                  :state="validateState('files')"
                  drop-placeholder="Drop file here..."
                  :disabled="isFormDisabled"
                  accept="image/*,.pdf,.doc,
                  .docx,.xml,application/msword,
                  application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                />
                <template v-if="$v.form.files.$error">
                  <m-invalid-feedback v-if="!$v.form.files.required" :state="true">
                    File is required
                  </m-invalid-feedback>
                  <m-invalid-feedback v-if="!$v.form.files.sizeLimitNotExceeded" :state="true">
                    File is too large (Max file size 3MB)
                  </m-invalid-feedback>
                </template>
              </b-form-group>
              <b-form-group class="new-opportunity-terms">
                <a-checkbox
                  id="new-opportunity-terms"
                  name="new-opportunity-terms"
                  :disabled="isFormDisabled"
                  v-model="terms"
                >
                  I hereby give consent for my personal data included in my application to be processed for the purposes
                  of the recruitment process. Read about our
                  <a href="/privacy-policy" target="_blank">Privacy Policy</a>. You can find it at the bottom of the
                  page.
                </a-checkbox>
                <template v-if="$v.terms.$error">
                  <m-invalid-feedback :state="$v.terms.sameAs"> Field is required </m-invalid-feedback>
                </template>
              </b-form-group>
              <div class="recaptcha-holder">
                <t-recaptcha-info />
              </div>
              <p>
                <m-arrow-button type="submit" variant="action-gradient" :disabled="isFormDisabled">
                  {{ submittingForm ? "Sending..." : "Apply now" }}
                </m-arrow-button>
              </p>
              <p v-if="submitFormSuccess !== null" :class="submitFormMessageClass">
                {{ submitFormSuccess ? SUBMIT_FORM_TEXT.SUCCESS : SUBMIT_FORM_TEXT.ERROR }}
              </p>
            </b-form>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { BForm, BFormGroup, BFormInput } from "bootstrap-vue";
import { required, email, minLength, maxLength, sameAs } from "vuelidate/lib/validators";
import submitFormMixin from "@/mixins/submit-form/submit-form";
import AFloatingLabel from "@/components/_atoms/floating-label/a-floating-label.vue";
import ACheckbox from "@/components/_atoms/checkbox/a-checkbox.vue";
import MArrowButton from "@/components/_molecules/arrow-button/m-arrow-button.vue";
import MFormFile from "@/components/_molecules/form-file/m-form-file.vue";
import MInvalidFeedback from "@/components/_molecules/invalid-feedback/m-invalid-feedback.vue";
import TRecaptchaInfo from "@/components/_templates/recaptcha-info/t-recaptcha-info.vue";
import DEFAULT_TERMS from "@/mixins/submit-form/enum";

export default {
  name: "TOfferApply",
  mixins: [submitFormMixin],
  components: {
    AFloatingLabel,
    ACheckbox,
    BForm,
    BFormGroup,
    BFormInput,
    MArrowButton,
    MFormFile,
    MInvalidFeedback,
    TRecaptchaInfo,
  },
  props: {
    message: {
      type: String,
    },
  },
  data() {
    return {
      form: {
        email: "",
        name: "",
        files: null,
        message: this.message,
      },
      terms: DEFAULT_TERMS,
    };
  },
  validations() {
    return {
      form: {
        email: {
          email,
          required,
        },
        name: {
          minLength: minLength(2),
          maxLength: maxLength(200),
        },
        files: {
          required,
          sizeLimitNotExceeded: (val) => {
            return this.isValidFileSize(val);
          },
        },
      },
      terms: {
        sameAs: sameAs(() => true),
      },
    };
  },
};
</script>
